import React, { useState, useEffect } from 'react';
// import ReactDOM from 'react-dom';
// import { connect } from 'react-redux';
import Tools from '../../tools';
import ChargeDemoItem from './ChargeDemoItem';
import { Button, Container, Modal, Row, Col, Form, Card } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
import API from '../../api';
import { Cookies, withCookies } from 'react-cookie';
import logoImg from "../../images/demo/logo_icon.png"
// import Enums from '../../enums'
// import { Calculator } from 'react-bootstrap-icons';
// import ChargePayment from './ChargePayment';

// import { useMappedState, useDispatch } from 'redux-react-hook';

export default withCookies(function ChargeDemoPartApp(props) {
    const [isFetched, setIsFetched] = useState(false);
    // const [isInit, setIsInit] = useState(false);
    const [productData, setProductData] = useState(null);
    // const [oid, setOid] = useState(props.match.params.oid);
    // const [orderData, setOrderData] = useState(null);
    // const [step, setStep] = useState(props.match.params.step);
    // const [status, setStatus] = useState(props.match.params.status);
    // const [currentProduct, setCurrentProduct] = useState(null);
    // const succUrl = "/charge/index";
    // const E_STS = {
    //     "succ": "付款成功",
    //     "fail": "付款失敗"
    // };

    // useEffect(() => {
    //     console.log(status)
    //     if (null != status) {
    //         let tmpStsTex = (E_STS.hasOwnProperty(status)) ? E_STS[status] : "unknown";
    //         alert(`訂單編號${oid}：${tmpStsTex}`);
    //         onFinishPointPayment();
    //     }
    // }, [props.match.params.status]);


    useEffect(() => {
        // console.log("updated", isFetched);
        if (false == isFetched) {
            API.init({ props });
            Tools.init();
            getData();
        }
        setIsFetched(true);
    }, [isFetched]);

    function getData() {
        // let tmpData = {
        //     item_type: 0
        // };
        // API.GetProducts(tmpData).
        //     then(onDataUpdated);
        onDataUpdated({ "data": [{ "platform_point": 3000, "item_id": "IT210809111838", "item_type": "後台點數", "price": 15000, "item_name": "基礎版 15,000元(3000點)", "item_description": "適合偶爾了解市場訊息，議題很單純，想快速、小規模回收問卷的團隊" }, { "platform_point": 6000, "item_id": "IT210809112018", "item_type": "後台點數", "price": 27000, "item_name": "行銷版 27,000元(6000點)", "item_description": "適合所有行銷、客戶服務、計畫提案團隊，各項方案推行前率先掌握市場資訊" }, { "platform_point": 12000, "item_id": "IT210809112146", "item_type": "後台點數", "price": 48000, "item_name": "企業版 48,000元(12000點)", "item_description": "適合大型企業、有定期產品開發、企劃設計需求，固定週期蒐集消費者反饋" }] });
    }

    function onDataUpdated(data) {
        console.log(data);
        // setIsAdmin(API.getIsAdmin());
        if (data && data.data && data.data.length > 0) {
            setProductData(data.data);
            // props.cookies.set('usr', data.display_name, { path: '/' });
        }
        // setIsInit(true);
    }

    function rednerProducts() {
        if (null == productData) return null;
        console.log(productData);
        let tmp = [];
        let discount = [
            "約為83折",
            "約為75折",
            "約為65折"
        ];
        productData.forEach((pdData, pdIdx) => {
            tmp.push(
                <Col xs={12} sm={4} style={{ marginBottom: "30px" }}>
                    <ChargeDemoItem data={pdData} classKey={pdIdx} key={pdIdx} onClick={onAddChargeOrder} isPromoted={pdIdx == 1} discount={discount[pdIdx]} />
                </Col>
            );
        });

        return (tmp);
    }

    function onAddChargeOrder(item_id) {
        //     let tmpData = {
        //         item_id: item_id,
        //         amount: 1
        //     };
        //     API.AddChargeOrder(tmpData).
        //         then((data) => {
        //             console.log(data);
        //             if (data) {
        //                 if (data.oid) {
        //                     console.log("購買成功, 訂單編號:" + data.oid);
        //                     // onFinishOrder(data.oid);
        //                     setOid(data.oid);

        //                     let tmp = [];
        //                     productData.forEach(val => val.item_id == item_id ? tmp.push(val) : null);
        //                     setCurrentProduct(tmp[0]);
        //                 }
        //                 else alert("Server error")
        //             } else {
        //                 alert("Server error");
        //                 console.log(data);
        //             }
        //         });
    }

    function render() {
        return (
            <div className="container-fluid pb-4 mb-4">
                <Row className="mb-3">
                    <Col xs={12}>
                        <h4><img src={logoImg} style={{ height: "25px", marginBottom: "3px", marginRight: "3px" }} /><strong>可以使用以下儲值方案會有折扣唷！</strong></h4>
                    </Col>
                    {/* <Col xs={6} sm={{ col: 4, offset: 8 }} className="text-right" style={{ marginTop: "-3rem", marginBottom: "2rem" }} >
                            <Button href="#/charge/calculator"><Calculator className="mr-1" />金額試算器</Button>
                        </Col> */}
                </Row>
                <Row className="text-center mt-3 mb-5">
                    {rednerProducts()}
                </Row>
            </div >
        );
    }
    return render();
})